import { Link } from "gatsby";
import React from "react";

export const Locations: React.FC = () => {
  return (
    <ul className="footer-nav">
      <li>
        <Link to={"/"} hrefLang="en-IN">
          <i className="fa fa-angle-right"></i>
          <span>Kochi</span>
        </Link>
      </li>
      <li>
        <Link to="/coimbatore/" hrefLang="en-IN">
          <i className="fa fa-angle-right"></i>
          <span>Coimbatore</span>
        </Link>
      </li>
      <li>
        <Link to="/chennai/" hrefLang="en-IN">
          <i className="fa fa-angle-right"></i>
          <span>Chennai</span>
        </Link>
      </li>
      <li>
        <Link to="/indore/" hrefLang="en-IN">
          <i className="fa fa-angle-right"></i>
          <span>Indore</span>
        </Link>
      </li>
      <li>
        <Link to="/hyderabad/" hrefLang="en-IN">
          <i className="fa fa-angle-right"></i>
          <span>Hyderabad</span>
        </Link>
      </li>
      <li>
        <Link to="/pune/" hrefLang="en-IN">
          <i className="fa fa-angle-right"></i>
          <span>Pune</span>
        </Link>
      </li>
      <li>
        <Link to="/trivandrum/" hrefLang="en-IN">
          <i className="fa fa-angle-right"></i>
          <span>Trivandrum</span>
        </Link>
      </li>
      <li>
        <Link to="/calicut/" hrefLang="en-IN">
          <i className="fa fa-angle-right"></i>
          <span>Calicut</span>
        </Link>
      </li>
      <li>
        <Link to="https://www.zartek.ca" hrefLang="en-IN" rel="noreferrer" target="_blank">
          <i className="fa fa-angle-right"></i>
          <span>Canada</span>
        </Link>
      </li>
      <li>
        <Link rel="noreferrer" to="https://www.zartek.qa" hrefLang="en-IN" target="_blank">
          <i className="fa fa-angle-right"></i>
          <span>Qatar</span>
        </Link>
      </li>
    </ul>
  );
};
